import { calculateLocatinVars } from '../../../libs/browser';
import { formatDate } from '../../../libs/date';
import { getWalletType } from '../../../libs/browser.js';
import { logoutAccount } from '../../../libs/state';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import CardComponent from '../../../components/CardComponent';
import CommonIconButton from '../../../components/CommonIconButton';
import Context from '../../../provider';
import HeaderBarComponent from '../../../components/HeaderBarComponent';
import IconAddHome from '../../../assets/hkdc/icons/AddHomeIcon';
import IconAndroidWalletEN from '../../../assets/hkdc/wallets/android/AndroidWalletEN';
import IconAndroidWalletTC from '../../../assets/hkdc/wallets/android/AndroidWalletTC';
import IconBenefitsRed from '../../../assets/hkdc/icons/BenefitsRedIcon';
import IconBenefitsWhite from '../../../assets/hkdc/icons/BenefitsWhiteIcon';
import IconEdit from '../../../assets/hkdc/icons/EditIcon';
import IconHKDC from '../../../assets/hkdc/icons/HKDCIcon';
import IconIOSWalletEN from '../../../assets/hkdc/wallets/ios/IOSWalletEN';
import IconIOSWalletSC from '../../../assets/hkdc/wallets/ios/IOSWalletSC';
import IconIOSWalletTC from '../../../assets/hkdc/wallets/ios/IOSWalletTC';
import IconJoin from '../../../assets/hkdc/icons/JoinIcon';
import IconPresent from '../../../assets/hkdc/icons/PresentIcon';
import IconRenewPayment from '../../../assets/hkdc/icons/RenewPaymentIcon';
import IconVoucher from '../../../assets/hkdc/icons/VoucherIcon';
import IconVoucherNone from '../../../assets/hkdc/icons/VoucherNoneIcon';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import QRCode from 'react-qr-code';
import React, { useContext, useEffect, useRef, useState } from 'react';
import config from '../../../config';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileHome() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const notificationNotReadCount = useNotificationsCount();

  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const nationRef = useRef(null);
  const scrollRef = useRef(null);
  const isScrolling = useIsScrolling(scrollRef.current);

  const { init, dispatch, tierMission, lang, me } = useContext(Context);

  const [isLogin, setIsLogin] = useState(false);
  const [pageData, setPageData] = useState(null);
  const [newsData, setNewsData] = useState([]);
  const [promotionsData, setPromotionsData] = useState([]);
  const [isClickChangePromotion, setIsClickChangePromotion] = useState(false);
  const autoSwitchRef = useRef(null);
  const [activeBannerIndex, setActiveBannerIndex] = useState(0);
  const [tierBenefitsData, setTierBenefitsData] = useState([]);
  const [vouchersData, setVouchersData] = useState([]);
  const [missionsData, setMissionsData] = useState([]);

  const fetchNewsData = async (page) => {
    try {
      const response = await memberApi.getNews({
        page,
        pageSize: 5
      });
      setNewsData((prevData) => [...prevData, ...(response?.list ?? []).filter((d) => !(prevData.find((p) => p.uri_name === d.uri_name)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  const fetchPromotionsData = async (page) => {
    try {
      const response = await memberApi.getPromotions({
        page,
        pageSize: 1000
      });
      setPromotionsData((prevData) => [...prevData, ...(response?.list ?? []).filter((d) => !(prevData.find((p) => p.uri_name === d.uri_name)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  const fetchTierBenefitsData = async (page) => {
    try {
      const response = await memberApi.getTierBenefits({
        page,
        pageSize: 1000
      });
      setTierBenefitsData((prevData) => [...prevData, ...(response?.list ?? []).filter((d) => !(prevData.find((p) => p.uri_name === d.uri_name)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  const getItem = async (page) => {
    try {
      const response = await memberApi.getItems({
        page,
        pageSize: 1000,
        status: 'available'
      });
      setVouchersData((prevData) => [...prevData, ...(response?.list ?? []).filter((i) => !(prevData.find((p) => p.id === i.id)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  const getMissions = async () => {
    try {
      const response = await memberApi.getMissions({});
      setMissionsData((prevData) => [...prevData, ...(response?.list ?? []).filter((i) => !(prevData.find((p) => p.id === i.id)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  const fetchGetWalletUrl = async (type) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getCardInfo();
      window.location.assign(response.pass_url[type]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  const fetchPageData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getPage({ ruri: 'join-membership-program' });
      console.log("fetchPagehData", page);

      setPageData(page);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      let timer = null;
      timer = setTimeout(() => {
        let scrollPosition = 0;
        console.log('home location', location.state);

        if (location.state && (location.state?.position || location.state?.toClass)) {
          if (location.state?.toClass) {
            const homeBarHeight = document.querySelector('.home-bar').clientHeight;
            scrollPosition = scrollRef.current.querySelector(location.state?.toClass)?.offsetTop - homeBarHeight;
          } else {
            console.log('location.state?.position', location.state?.position);

            scrollPosition = location.state?.position;
          }
          sessionStorage.setItem('scrollPosition', scrollPosition);
        } else {
          scrollPosition = sessionStorage.getItem('scrollPosition');
        }
        scrollRef.current?.scrollTo(0, parseInt(scrollPosition, 10));
        if (timer) {
          clearTimeout(timer);
        }
      }, 1000);

    }

    return () => {
      if (scrollRef.current) {
        sessionStorage.setItem('scrollPosition', scrollRef.current.scrollTop);
      }
    };
  }, [scrollRef]);

  // This page only allow logged in user
  useEffect(() => {
    if (init) {
      fetchNewsData(1);
      fetchTierBenefitsData(1);
      fetchPageData();
      if (!me) {
        fetchPromotionsData(1);
      } else {
        if (me?.status === 'new') {
          logoutAccount({ dispatch });
        }
        if (me?.status === 'activated') {
          setIsLogin(true);
          getItem(1);
          getMissions();
        }
        if (me?.status === 'disabled') navigate(`${config.basename}no-permission`);
      }

    }
  }, [init, me, navigate]);

  useEffect(() => {
    autoSwitchRef.current = promotionsData.length;
  }, [promotionsData]);

  useEffect(() => {
    let timer;

    if (!isClickChangePromotion) {
      timer = setInterval(() => {
        setActiveBannerIndex((prevIndex) => {
          if (prevIndex === autoSwitchRef.current - 1) {
            return 0;
          } else {
            return prevIndex + 1;
          }
        });
      }, 3000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [isClickChangePromotion]);

  const resetAutoPlay = () => {
    setTimeout(() => {
        setIsClickChangePromotion(false);
    }, 1000);
};

  const addWallet = () => {
    const type = getWalletType();

    fetchGetWalletUrl(type);

  };
  const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 检查用户代理字符串中是否含有 iPhone、iPad 或 iPod
    return /iPhone|iPad|iPod/.test(userAgent) && !window.MSStream;
  };

  return (
    (
      <div className='mobile-home-page'>

        <HeaderBarComponent
          homeIcon={
            <IconHKDC
              style={{ width: '5rem', height: '2.78rem' }}
              onClick={(e) => {
                e.stopPropagation();
                window.location.assign('https://www.hkdesigncentre.org/ ');
              }}
            />
          }
        />

        <div ref={scrollRef}
          onScroll={(e) => {
            e.stopPropagation();
            sessionStorage.setItem('scrollPosition', scrollRef.current.scrollTop);
          }}
          className='y-overflow content-container'>

          { !isLogin &&
            <>
              <div className='red-block join-section-cont'>
                <div className='mobile-join-icon-cont'>
                  <IconJoin
                    className="join-icon"
                    size="large" />
                </div>
                <div className='join-text-cont'>
                  <div className='join-text-title'>
                    {pageData && pageData.title[lang]}
                  </div>
                  <div className='join-text-desc'>
                    {pageData && pageData.meta_description[lang].split('\r\n')
                      .map((item, index) => {
                        if (index > 0) {
                          return (
                            <>
                              <br/>
                              {item}
                            </>
                          );
                        } else {
                          return item;
                        }
                      })
                    }
                  </div>
                  <CommonIconButton
                    text={t('home-before.join-text')}
                    endIcon= {<KeyboardArrowRightIcon />}
                    alignItems = "unset"
                    btnBackgroundColor= "#004899"
                    btnColor = "#ffffff"
                    btnWidth= "max-content"
                    btnPadding = "0.75rem 1.25rem 0.75rem 2rem"
                    btnFontSize = "1.125rem"
                    btnFontWeight = "500"
                    onClick={() => {
                      setTimeout(() => {
                        navigate(`${config.basename}${"join-membership-program"}`, {
                          state: {
                            defaultTierId: tierBenefitsData && tierBenefitsData.length > 0 ? tierBenefitsData[0].id : -1,
                            defaultTierType: tierBenefitsData && tierBenefitsData.length > 0 ? tierBenefitsData[0].uri_name.replace('/tier-', '') : ''
                          }
                        });
                      }, 200);
                    }}
                  />
                </div>
              </div>

              {
                promotionsData && promotionsData.length > 0 &&
                <div className='section-2-cont'>
                  <div className='block-cont' >
                    <div className='red-block block'/>
                  </div>
                  <div className='banner'>
                    <div className='warp'>
                      <div className='item'>
                        <div className='red-block block' />
                        <div className='img-cont'
                          onClick={(e) => {
                            e.stopPropagation();
                            if (promotionsData[activeBannerIndex].external_url[lang]) {
                              window.open(promotionsData[activeBannerIndex].external_url[lang]);
                            }
                          }}
                          style={{
                            backgroundImage: `url(${promotionsData[activeBannerIndex].cover ? promotionsData[activeBannerIndex].cover[lang] : ''})`
                          }}
                        />
                      </div>
                    </div>
                    <div ref={nationRef} className='page-nation'>
                      { promotionsData.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className={`item${index === activeBannerIndex ? ' active' : ''}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (nationRef.current && nationRef.current.children && nationRef.current.children[index]) {
                                  nationRef.current.scrollTo({
                                    top: 0,
                                    left: nationRef.current.children[index].offsetLeft - 150,
                                    behavior: 'smooth'
                                  });
                                }
                                setIsClickChangePromotion(true);
                                setActiveBannerIndex(index);
                                resetAutoPlay();
                              }}
                            />
                          );
                        })
                      }
                    </div>
                  </div>
                </div>
              }

              <div className='benefits-section-cont'>
                <div className='benefits-title-cont'>
                  <IconBenefitsRed
                    className="icon"
                    size="large" />
                  <div className='title'>
                    {t('common.tier-benefits')}
                  </div>
                </div>
                <div className='benefits-cont'>
                  {
                    tierBenefitsData && tierBenefitsData.length > 0 && tierBenefitsData.map((item, index) => {
                      const tierType = item.uri_name.replace('/tier-', '');
                      return (
                        <CardComponent
                          key={index}
                          cardBg={item.cover[lang]}
                          cardTitle={item.title[lang]}
                          cardDesc={item.subtitle[lang]}
                          cardImgClass={'tier-card-img'}
                          contentClass={'tier-card-content'}
                          btn={
                            <CommonIconButton
                              text= {t('home-before.card-btn-3')}
                              alignItems = "unset"
                              backgroundColor= "#000000"
                              btnBackgroundColor= "#000000"
                              btnColor = "#ffffff"
                              width= "max-content"
                              padding = "0.25rem 0.5rem"
                              btnPadding="0rem"
                              btnFontSize = "0.875rem"
                              btnFontWeight = "700"
                              onClick={(e) => {
                                sessionStorage.setItem('scrollPosition', scrollRef.current.scrollTop);
                                navigate(`${config.basename}benefit/${tierType}`);
                              }}
                            />
                          }
                        />
                      );
                    })
                  }
                </div>
              </div>
              <div className='section-4-cont'>
                <div className="red-block block-1" />
                <div className="red-block block-2" />
              </div>
            </>
          }

          {
            isLogin &&
            <>
              <div className="user-card-section-cont">
                <div className="user-card-text-cont">
                  <div className="user-card-text">
                    <div className="icon-cont">
                      <IconBenefitsWhite
                        className="icon"
                        size="large" />
                    </div>
                    <div className="text-cont">
                      <div className="welcome-text">
                        {t('home-after.welcome')}
                      </div>
                      {
                        me && me.loyalty_account &&
                        <div className="user-name-text">
                          {`${me.loyalty_account.first_name} ${me.loyalty_account.last_name}`}
                        </div>
                      }
                    </div>
                  </div>
                  <div className="edit-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`${config.basename}setting/profile/user`);
                    }}
                  >
                    <IconEdit
                      className="icon"
                      size="large" />
                    <div className="text">
                      {t('home-after.btn')}
                    </div>
                  </div>
                </div>
                <div
                  className="user-card-cont"
                  style={{ backgroundImage: `url(${tierMission?.current_tier?.image?.[lang]})` }}
                >
                  {
                    me && me.loyalty_account?.unique_id &&
                    <QRCode
                      className='qrcode'
                      size={256}
                      value={me?.loyalty_account?.unique_id}
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch({ type: 'SWITCH_USER_INFO', payload: { open: true } });
                      }}
                    />
                  }
                  <div className="func-cont">
                    <div className="view-benefits-cont">
                      <div style={{ color: tierMission?.current_tier?.color ? tierMission?.current_tier?.color : undefined }} className="title">
                        {tierMission?.current_tier?.title?.[lang]}
                      </div>
                      <div className="view-btn" onClick={() => {
                        let item = tierBenefitsData.find((item) => item.uri_name.includes(tierMission?.current_tier?.code));
                        if (!item) {
                          item = tierBenefitsData.find((item) => item.uri_name.includes('patron'));
                        }
                        const tierType = item.uri_name.replace('/tier-', '');
                        console.log('view-btn', tierType);
                        navigate(`${config.basename}benefit/${tierType}`);
                      }}>
                        <div className="text-cont-underline">
                          <div style={{ color: tierMission?.current_tier?.color ? tierMission?.current_tier?.color : undefined }} className="text">
                            {t('home-after.card-btn')}
                          </div>
                          <div style={{ borderColor: tierMission?.current_tier?.color ? tierMission?.current_tier?.color : undefined }} className="middle-line"/>
                        </div>
                        <KeyboardArrowRightIcon style={{ color: tierMission?.current_tier?.color ? tierMission?.current_tier?.color : undefined }} />
                      </div>
                    </div>
                    <Button
                      style={{
                        backgroundColor: tierMission?.current_tier?.color ? `${tierMission?.current_tier?.color}64` : undefined
                      }}
                      variant='contained'
                    >
                      {`${t('home-after.coupon-expiry-1')}${tierMission?.expire_at ? formatDate(tierMission?.expire_at, lang) : ' -'}`}
                    </Button>
                  </div>
                </div>
                <div className="card-func-cont">
                  <div
                    className="func-btn"
                    style={{
                      backgroundColor: '#004899',
                      justifyContent: 'center',
                      width: me && me.loyalty_account?.tier_renewal && me.loyalty_account?.tier_renewal.expire_from_now <= 30 ? '50%' : undefined
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch({ type: 'SWITCH_IMAGE_DIALOG', payload: { open: true } });
                    }}
                  >
                    <div
                      className="btn-cont"
                      style={{ flexDirection:  me && me.loyalty_account?.tier_renewal ? 'column' : 'row' }}
                    >
                      <IconAddHome
                        className="icon"
                        size="large" />
                      <div className="text">
                        {t('home-after.shortcut-1')}
                      </div>
                    </div>
                  </div>
                  {
                    me && me.loyalty_account?.tier && me.loyalty_account?.tier.wallet_enabled === 1 &&
                    <div
                      style={{
                        backgroundColor: '#E53323',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: me && me.loyalty_account?.tier_renewal && me.loyalty_account?.tier_renewal.expire_from_now <= 30 ? '50%' : undefined
                      }}
                      className="func-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        addWallet();
                      }}
                    >
                      {
                        !isIOS() ?
                        lang === 'en' ? <IconAndroidWalletEN className="android-en" /> : <IconAndroidWalletTC className="android-tc" /> :
                        lang === 'en' ? <IconIOSWalletEN className="ios-en" /> : lang === 'tc' ? <IconIOSWalletTC className="ios-tc" /> : <IconIOSWalletSC className="ios-sc" />
                      }
                    </div>
                  }
                  {
                    me && me.loyalty_account?.tier_renewal && tierMission?.expire_at && me.loyalty_account?.tier_renewal.expire_from_now <= 30 &&
                    <div
                      style={{ backgroundColor: '#000000', width: '100%', justifyContent: 'center' }}
                      className="func-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`${config.basename}renewal`);
                      }}
                    >
                      <div className="btn-cont">
                        <IconRenewPayment
                          className="icon"
                          style={{ fontSize: '1.5rem', margin: '0' }}
                          size="large" />
                        <div className="text">
                          {t('home-after.shortcut-3')}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div className="section-login-1-cont">
                <div className="red-block block" />
              </div>

              <div className="vouchers-section-cont">
                <div className="icon-title-cont">
                  <div className="icon-cont">
                  <IconBenefitsRed
                      className="icon"
                      size="large" />
                  </div>
                  <div className="title">
                    {t('home-after.title-1')}
                  </div>
                </div>
                {
                  vouchersData.length > 0 &&
                  <div className="content-list-cont">
                    {
                      vouchersData.map((item, index) => {
                        return (
                          <div key={index} className="content-item-cont"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`${config.basename}voucher/${item.token}`, {
                                state: {
                                  data: item.token
                                }
                              });
                          }}>
                            <div className="item-icon-title">
                              <div className="icon-cont">
                                <IconVoucher
                                  className="icon"
                                  size="large" />
                              </div>
                              <div className="title-cont">
                                <div className="title">
                                  {item.title[lang]}
                                </div>
                                <div className="time">
                                  {`${t('home-after.coupon-expiry-1')}${formatDate(item.expire_at, lang)}`}
                                </div>
                              </div>
                            </div>
                            <div className="item-btn">
                              <KeyboardArrowRightIcon
                                className="icon"
                                size="large" />
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                }
                {
                  (!vouchersData || vouchersData.length === 0) &&
                  <div className="voucher-list-none">
                    <IconVoucherNone
                      className="icon"
                      size="large" />
                    <div className="text">
                      {t('none-data.coupon')}
                    </div>
                  </div>
                }
                <div className="view-history-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`${config.basename}profile`);
                  }}
                >
                  <div className="text">
                    {t('home-after.coupon-btn')}
                  </div>
                </div>
              </div>

              <div className="section-login-2-cont red-block"/>

              {
                missionsData.length > 0 &&
                <div className="news-mission-section-cont">
                  <div className="bar-cont">
                    <div className="bar-icon-title">
                      <div className="icon-cont">
                        <IconBenefitsRed
                          className="icon"
                          size="large" />
                      </div>
                      <div className='title'>
                        {t('home-after.title-2')}
                      </div>
                    </div>
                    {/* <div className="bar-btn">
                      <div className="text">
                        View All
                      </div>
                    </div> */}
                  </div>
                  <div className="content-cont">
                    {
                      missionsData.length > 0 && missionsData.map((item, index) => {
                        return (
                          <div key={index} className='item'
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`${config.basename}mission/${item.code}`, {
                                state: {
                                  id: item.code
                                }
                              });
                            }}
                          >
                            <div className='item-img' style={{ backgroundImage: `url(${item.image[lang]})` }} />
                            <div className='mission-item-content'>
                              <div className='item-text-cont'>
                                <div className='item-text-time'>
                                  {`${t('home-after.mission-expiry-2')}${formatDate(item.expire_at, lang)}`}
                                </div>
                                <div className='item-text-desc'>
                                  {item.title[lang]}
                                </div>
                              </div>
                              <div className='schedule-cont'>
                                <div className="icon-text-cont">
                                  <div className="icon-section">
                                    <div className="icon-cont">
                                      <IconPresent
                                        className="icon"
                                        size="large" />
                                    </div>
                                    {
                                      item.achieve && item.achieve.length > 0 &&
                                      <div className="text">
                                        {`${item.achieve?.[0].quantity} ${item.achieve?.[0].title[lang]}`}
                                      </div>
                                    }
                                  </div>
                                  <div className="text-cont">
                                    <div className="progress">
                                      {item.progress.current}
                                    </div>
                                    <div className="total">
                                      {`/${item.progress.total}`}
                                    </div>
                                  </div>
                                </div>
                                <div className="progress-bar">
                                  <div className="bar" />
                                  <div className="inner" style={{ width: `${item.progress.percentage}%` }} />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
              }
            </>
          }

          {
            newsData && newsData.length > 0 &&
            <div className="news-mission-section-cont">
              <div className="bar-cont">
                <div className="bar-icon-title">
                  <div className="icon-cont">
                    <IconBenefitsRed
                      className="icon"
                      size="large" />
                  </div>
                  <div className='title'>
                    {t('common.news')}
                  </div>
                </div>
                <CommonIconButton
                  text= {t('home-before.btn-4')}
                  alignItems = "unset"
                  backgroundColor= "#000000"
                  btnBackgroundColor= "#000000"
                  btnColor = "#ffffff"
                  btnWidth= "max-content"
                  padding = "0.25rem 0.75rem"
                  btnPadding="0rem"
                  btnFontSize = "0.875rem"
                  btnFontWeight = "400"
                  onClick={() => {
                    navigate(`${config.basename}news`);
                  }}
                />
              </div>
              <div className="content-cont">
                {
                  newsData && newsData.length > 0 && newsData.map((news, index) => {
                    return (
                    <CardComponent
                      key={index}
                      cardBg={news.cover[lang]}
                      cardTitle={news.title[lang]}
                      cardDesc={news.subtitle[lang]}
                      cardStyle={{
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                      cardImgClass={'card-img'}
                      contentClass={'news-card-content'}
                      btn={
                        <CommonIconButton
                          text= {t('home-before.card-btn-4')}
                          alignItems = "unset"
                          backgroundColor= "#000000"
                          btnBackgroundColor= "#000000"
                          btnColor = "#ffffff"
                          width= "max-content"
                          padding = "0.25rem 0.5rem"
                          btnPadding="0rem"
                          btnFontSize = "0.875rem"
                          onClick={(e) => {
                            if (news.external_url && news.external_url[lang]) {
                              window.location.assign(news.external_url[lang]);
                            } else {
                              navigate(`${config.basename}news-detail/${news.id}`, {
                                state: {
                                  id: news.id
                                }
                              });
                            }
                          }}
                        />
                      }
                    />);
                  })
                }
              </div>
            </div>
          }

          <LogoFooterComponent />
        </div>
      </div>
    )
  );
}